import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';

import { ReportService } from '../../../../../common/services/Report.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { TicketTypeService } from '../../../../../common/services/TicketType.service';
import { ServiceService } from '../../../../../common/services/Service.service';
import { PriorityService } from '../../../../../common/services/Priority.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { ExportService } from '../../../../../common/services/Export.service';
import { ToastrService } from 'ngx-toastr';
import { AgentConst, Filter } from './agentV1.const';
import { ReportGroupBy } from '../filter/filter.const';
import { TimeWorker } from '../../../../../common/utils/timeWorker';
import * as _ from 'lodash';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { BsModalService } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Role } from '../../setting/expert/agent/agent.const';

declare var $: any;
declare var Chartist: any;

@Component({
  selector: 'report-agentV1',
  templateUrl: 'agentV1.template.html',
  styleUrls: ['../reportv2.component.css'],
  providers: [
    ReportService,
    TicketService,
    GroupService,
    UserService,
    TicketTypeService,
    ServiceService,
    PriorityService,
    ExportService,
  ],
})
export class AgentV1Component extends BaseListComponent {
  public isFilterGroup: boolean = false;
  public data_page_divide: any;
  public channel: any = 'call';
  public exportData: any = [];
  public agents: any = [];
  public allAgent: any = [];
  public allGroup: any = [];
  public groupBys = Filter;
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private userService: UserService,
    private exportService: ExportService,
    private groupService: GroupService
  ) {
    super(changeDetector, toastr, modalService);
    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
      source: '-1',
      tenantId: this.user.tenant_id,
      groups: '',
      queues: '',
      calleds: '',
      campaigns: '',
      agents: '',
      groupBy: `${ReportGroupBy.Agent}`,
    };
    this.displayColumns = AgentConst.displayColumns(this.modelFilter.groupBy);
  }

  async ngOnInit() {
    if (this.user.role == Role.TeamLeader) {
      this.groupBys = this.groupBys.filter(item => item.id !== ReportGroupBy.Group);
    }
    this.is_loading = true;
    this.isFilterGroup = this.getIsFilterGroup();
    Observable.forkJoin([this.userService.all(), this.groupService.allGroup({ target: 'user' })]).subscribe(data => {
      this.getAgentList(data[0]);
      this.getAllGroup(data[1]);
      this.loadData(1);
    });
  }

  getIsFilterGroup() {
    return this.user.role !== Role.TeamLeader;
  }

  async changeTime(type) {
    let start: any = moment().format('YYYY-MM-DD HH:mm');

    const end: any = moment().format('YYYY-MM-DD HH:mm');

    switch (type) {
      case 'year': {
        start = moment().add('-365', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'month': {
        start = moment().add('-30', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'week': {
        start = moment().add('-7', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'day': {
        start = moment().add('-1', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'hour': {
        start = moment().add('-1', 'hours').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'minute': {
        start = moment().add('-30', 'minutes').format('YYYY-MM-DD HH:mm');
        break;
      }
      default:
        break;
    }
    this.modelFilter['from'] = start;
    this.modelFilter['to'] = end;
    await this.loadData(1);
  }

  async getAgentList(res) {
    const agentList = [];
    res.data.list.forEach((c: any) => {
      agentList.push({
        text: c.name,
        id: c.agent_id,
        email: c.email,
        phone: c.phone,
        group_id: c.group_id,
      });
    });
    this.allAgent = agentList;
  }

  async getAllGroup(res) {
    const list = [];
    res.data.forEach((c: any) => {
      list.push({
        text: c.name,
        id: c.id.toString(),
      });
    });
    this.allGroup = list;
  }

  async loadData(research?: any) {
    if (research) {
      this.currentPage = 1;
    }
    const filter = _.assign({}, this.modelFilter);

    if (Array.isArray(filter.groupBy)) {
      filter.groupBy = filter.groupBy.join(',');
    }
    const agents = this.allAgent;

    if (this.user.role == Role.TeamLeader) {
      filter.groups = [this.user.group_id];
    }

    if (Array.isArray(filter.groups)) {
      const groups = filter.groups.map(f => Number(f));
      filter.agents = agents
        .filter(a => groups.includes(Number(a.group_id)))
        .map(a => a.id)
        .filter(a => a && a.length === 4)
        .join(',');
      delete filter.groups;
    } else if (filter.groups) {
      const groups = filter.groups.split(',').map(f => Number(f));
      filter.agents = agents
        .filter(a => groups.includes(Number(a.group_id)))
        .map(a => a.id)
        .filter(a => a && a.length === 4)
        .join(',');
      delete filter.groups;
    }
    if (Array.isArray(filter.queues)) {
      filter.queues = filter.queues.join(',');
    }
    if (Array.isArray(filter.calleds)) {
      filter.calleds = filter.calleds.join(',');
    }
    if (Array.isArray(filter.campaigns)) {
      filter.campaigns = filter.campaigns.join(',');
    }

    const agentFilter = this.modelFilter.agents && this.modelFilter.agents.split(',');

    if (Array.isArray(agentFilter) && agentFilter.length > 0) {
      filter.agents = agentFilter.join(',');
    }
    if (!filter.groupBy.includes(ReportGroupBy.Agent) && !filter.groupBy.includes(ReportGroupBy.Group)) {
      filter.groupBy = ReportGroupBy.Agent + ',' + filter.groupBy;
    }
    Object.keys(filter).forEach(key => {
      if (filter[key] === '') {
        delete filter[key];
      }
    });

    this.reportService.reportAgent(filter).subscribe(res => {
      if (res.data) {
        this.data = res.data;
      } else {
        this.data = [
          {
            source: 0,
            totalCalls: 0,
            totalMissCalls: 0,
            totalAnswerCalls: 0,
            avgSpeedAnswer: 0,
            avgAcdTime: 0,
            avgDuration: 0,
            avgHoldTime: 0,
            totalAcdTime: 0,
            totalDuration: 0,
            missRatio: 0,
          },
        ];
      }
      this.data.map(res => {
        res.display_name = AgentConst.displayNameColumn(res, this.allAgent);
        res.groupName = AgentConst.displayGroup(res, this.allGroup);
        res.missRatio = AgentConst.displayMissRatioColumn(res.missRatio);
        res.slaRatio = AgentConst.displayMissRatioColumn(res.slaRatio);
        res.slaRatio20 = AgentConst.displayMissRatioColumn(res.slaRatio20);
        res.avgSpeedAnswer = TimeWorker.formatSecondToHour(res.avgSpeedAnswer);
        res.avgAcdTime = TimeWorker.formatSecondToHour(res.avgAcdTime);
        res.avgDuration = TimeWorker.formatSecondToHour(res.avgDuration);
        res.avgHoldTime = TimeWorker.formatSecondToHour(res.avgHoldTime);
        res.avgWaitingTime = TimeWorker.formatSecondToHour(res.avgWaitingTime);
        res.avgMissDuration = TimeWorker.formatSecondToHour(res.avgMissDuration);
        res.longestAcdTime = TimeWorker.formatSecondToHour(res.longestAcdTime);
        return res;
      });
      this.totalItem = this.data.length;
      this.totalPage =
        this.data.length % this.page_size != 0
          ? Math.floor(this.data.length / this.page_size) + 1
          : Math.floor(this.data.length / this.page_size);
      const begin = (this.currentPage - 1) * this.page_size;
      const end = this.currentPage * this.page_size;
      this.data_page_divide = this.data.slice(begin, end);
      this.is_loading = false;
    });
  }

  async submitFilter(item?: any) {
    if (item) {
      this.modelFilter = item;
    }
    if (this.modelFilter.from) {
      this.modelFilter.from = moment(this.modelFilter.from).format('YYYY-MM-DD HH:mm');
    }
    if (this.modelFilter.to) {
      this.modelFilter.to = moment(this.modelFilter.to).format('YYYY-MM-DD HH:mm');
    }
    this.displayColumns = AgentConst.displayColumns(this.modelFilter.groupBy);
    await this.loadData(1);
  }

  export() {
    this.exportData = [];
    this.data.forEach(data => {
      const dataExport = {};
      this.displayColumns.forEach(d => {
        dataExport[d.title] = data[d.key];
      });
      this.exportData.push(dataExport);
    });
    this.exportService.exportExcel(
      this.exportData,
      'Báo cáo chuyên viên ' + moment(new Date()).format('YYYY-MM-DD HH-mm')
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/agentV1/agentV1.component.ts